import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files directly
import ruTranslation from './locales/ru.json';
import kzTranslation from './locales/kz.json';
import enTranslation from './locales/en.json';

const resources = {
  ru: { translation: ruTranslation },
  kz: { translation: kzTranslation },
  en: { translation: enTranslation },
};

// Get language from URL path
const getLanguageFromPath = () => {
  const path = window.location.pathname;
  const match = path.match(/^\/(ru|kz|en)/);
  return match ? match[1] : 'ru';
};

// Set HTML lang attribute
const setHtmlLangAttribute = (lang) => {
  document.documentElement.lang = lang;
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getLanguageFromPath(),
    fallbackLng: 'ru',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

// Set initial HTML lang attribute
setHtmlLangAttribute(i18n.language);

// Update HTML lang attribute when language changes
i18n.on('languageChanged', (lng) => {
  setHtmlLangAttribute(lng);
});

export default i18n;
export { getLanguageFromPath };
